var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { endAction, startAction } from "./loader.actions";
export const reducers = [
    [
        startAction,
        (state, { payload: { id } }) => {
            return Object.assign(Object.assign({}, state), { [id]: true });
        },
    ],
    [
        endAction,
        (state, { payload: { id } }) => {
            const _a = state, _b = id, _ = _a[_b], stateWithoutAction = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return stateWithoutAction;
        },
    ],
];
